import { Model } from "@vuex-orm/core";
import moment from "moment";
import shortid from 'shortid'

import Resource from './Resource'
import CompanyUserResource from './CompanyUserResource'
import User from './User'
import Device from "./Device";

export default class CompanyUser extends Model {
  static entity = "companyUsers";
  static fields() {
    return {
      id: this.attr('tmp/' + shortid.generate()),
      companyId: this.attr(null),
      userId: this.attr(null),
      user: this.belongsTo(User, 'userId'),
      isAdmin: this.attr(null),
      isSuper: this.attr(null),
      dateUpdated: this.attr(null),
      dateCreated: this.attr(moment().toISOString()),
      dateRemoved: this.attr(null),
      status: this.attr('active')
    }
  }

  static hasPermission(userId, resourceName, operation) {
    let companyUser = CompanyUser.query().where('userId', userId).first()
    let resource = Resource.query().where('name', resourceName).first()
    
    if((companyUser && companyUser.isAdmin) || (companyUser && companyUser.isSuper))
        return true

    if(companyUser && companyUser.id && resource && resource.id) {
        return !!(CompanyUserResource.query().where(record => 
            record.companyUserId === companyUser.id && 
            record.resourceId === resource.id &&
            record.operation === operation).first())
    } else return false
  }

  deleteDependecies() {
    if(this.userId) {
      const user = User.find(this.userId)
      Device.delete((device) => device.userId === user.id)
      user.$delete()
    }
  }

}
